import { apiRequestDev } from './apiRequest';

export const getCases = async (config, userId) => apiRequestDev(config, `/cases/all/${userId}`);

export const getCaseInfo = async (config, userId, caseId) => apiRequestDev(config, `/cases/${userId}/${caseId}`);

export const createEmailBasedCase = async (config, userId, feedbackId) => {
  return apiRequestDev(config, '/cases/create_from_email', 'post', {
    user_id: userId,
    feedback_id: feedbackId,
  });
};

export const createCase = async (
  config,
  userId,
  constituentId,
  name,
  phone,
  email,
  address,
  postalCode,
  type,
  subtype,
  importance,
  description,
  memberNotes,
  source,
) => {
  return apiRequestDev(config, '/cases/create', 'post', {
    user_id: userId,
    constituent_id: constituentId,
    name,
    phone,
    email,
    address,
    postal_code: postalCode,
    type,
    subtype,
    importance,
    description,
    member_notes: memberNotes,
    case_source: source,
  });
};

export const saveCase = async (
  config,
  caseId,
  userId,
  constituentId,
  name,
  phone,
  email,
  address,
  postalCode,
  type,
  subtype,
  importance,
  description,
  memberNotes,
  source,
) => {
  return apiRequestDev(config, `/cases/${caseId}/update`, 'patch', {
    user_id: userId,
    constituent_id: constituentId,
    name,
    phone,
    email,
    address,
    postal_code: postalCode,
    type,
    subtype,
    importance,
    description,
    member_notes: memberNotes,
    case_source: source,
  });
};

export const deleteCase = async (config, caseId, userId) =>
  apiRequestDev(config, `/cases/${caseId}/delete?user_id=${userId}`, 'delete');
